import React from "react";
import { useSelector } from "react-redux";
import SimpleBarReact from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

function AssetList({
  showAlert,
  assetentryvalue,
  setAssetEntryValue,
  activeentry,
  setActiveEntry,
  handleNewPerformance,
  performance,
  handleFileUpload,
  setFileUpload,
  setAllowUpdate
}) {
  const { tempdata, tododata, todoperformance, performancegroup } = useSelector(
    (state) => state.todoPerformance
  );

  return (
    <div
      className="bg-[--bg-color-50] h-screen rounded py-2 px-3"
      style={{
        maxHeight: !showAlert ? "calc(100vh - 198px)" : "calc(100vh - 252px)",
      }}
    >
      <h4 className="text-sm leading-4 font-bold tracking-tight text-[#535860]">
        Assets
      </h4>
      <SimpleBarReact
        style={{
          maxHeight: showAlert ? "calc(100vh - 282px)" : "calc(100vh - 255px)",
        }}
      >
        <div className="py-3">
          <div className="space-y-2 overflow-x-hidden">
            {tempdata?.map((item, index) => {
              const assetname = item.asset_name + "-" + item.asset_type;
              return (
                <div
                  className={`border 
                  ${
                    tododata?.can_perform
                      ? "cursor-pointer"
                      : "cursor-not-allowed pointer-events-none"
                  }
                  ${
                    activeentry.findIndex((ele) => ele === assetname) !== -1
                      ? "bg-[--bg-color-500] hover:bg-[--bg-color-700]"
                      : "border-[#D9D9D9] hover:border-slate-400 bg-white"
                  } rounded w-full h-[50px] flex justify-center items-center relative`}
                  onClick={(e) => {
                    if (tododata?.can_perform) {
                      const value = item.asset_name + "-" + item.asset_type;
                      setFileUpload([]);
                      let found = false;
                      if (!performance) {
                        todoperformance.forEach((ele) => {
                          if (ele.value === value) {
                            found = true;
                            const assetexist = activeentry.findIndex(
                              (element) => element === value
                            );
                            if (assetexist === -1) {
                              setActiveEntry([assetname]);
                              setAssetEntryValue([{ based_on: value, asset_entry_id: item.asset_entry_id }]);
                              const Index =
                                performancegroup.todo_performances.findIndex(
                                  (item) => item.value === value
                                );
                              handleFileUpload(
                                performancegroup.todo_performances[Index]
                                  .files
                              );
                            } else {
                              setActiveEntry([]);
                              setAssetEntryValue([{ based_on: "" }]);
                              handleFileUpload([]);
                            }
                            return;
                          }
                        });
                      }
                      if (!found) {
                        handleNewPerformance();
                        handleFileUpload([]);
                        const check = todoperformance.findIndex(
                          (ele) => ele.value == activeentry[0]
                        );
                        if (check !== -1) {
                          setActiveEntry([value]);
                          setAssetEntryValue([{ based_on: value, asset_entry_id: item.asset_entry_id }]);
                        } else if (check === -1) {
                          const test = activeentry.findIndex(
                            (item) => item === value
                          );
                          if (test === -1) {
                            setActiveEntry((prev) => [...prev, assetname]);
                            if (assetentryvalue[0].based_on === "") {
                              setAssetEntryValue([{ based_on: value, asset_entry_id: item.asset_entry_id }]);
                            } else {
                              setAssetEntryValue((prev) => [
                                ...prev,
                                { based_on: value, asset_entry_id: item.asset_entry_id },
                              ]);
                            }
                          } else {
                            setActiveEntry((prev) => {
                              const filterdata = prev.filter(
                                (ele) => ele !== assetname
                              );
                              return [...filterdata];
                            });
                            setAssetEntryValue((prev) => {
                              const filterdata = prev.filter(
                                (ele) => ele.based_on !== value
                              );
                              if (filterdata.length === 0) {
                                let empty = [{ based_on: "" }];
                                return [...empty];
                              }
                              return [...filterdata];
                            });
                          }
                        }
                      }
                    } else {
                      setActiveEntry([]);
                      setAssetEntryValue("");
                    }
                  }}
                >
                  <div className="absolute top-1 right-1">
                    <div
                      className={`w-3 h-3 border-2 rounded-full flex ${
                        activeentry.findIndex((ele) => ele === assetname) !== -1
                          ? "border-white"
                          : "border-[--bg-color-500]"
                      }`}
                    >
                      <div
                        className={`flex-1 ${
                          item.type !== undefined
                            ? item.type === "save"
                              ? activeentry.findIndex(
                                  (ele) => ele === assetname
                                ) !== -1
                                ? "bg-white"
                                : "bg-[--bg-color-500]"
                              : activeentry.findIndex(
                                  (ele) => ele === assetname
                                ) !== -1
                              ? "bg-white"
                              : "bg-[--bg-color-500]"
                            : ""
                        } `}
                      ></div>
                      <div
                        className={`flex-1 ${
                          item.type !== undefined
                            ? item.type === "save"
                              ? ""
                              : activeentry.findIndex(
                                  (ele) => ele === assetname
                                ) !== -1
                              ? "bg-white"
                              : "bg-[--bg-color-500]"
                            : ""
                        }`}
                      ></div>
                    </div>
                  </div>
                  <div className="text-center space-y-1">
                    <p
                      className={`text-[11px] ${
                        activeentry.findIndex((ele) => ele === assetname) !== -1
                          ? "text-white"
                          : "text-[#878B93]"
                      } leading-3 font-normal tracking-tight`}
                    >
                      {item.asset_type}
                    </p>
                    <p
                      className={`text-[13px] ${
                        activeentry.findIndex((ele) => ele === assetname) !== -1
                          ? "text-white"
                          : "text-[#878B93]"
                      } leading-3 font-semibold tracking-tight`}
                    >
                      {item.asset_name}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </SimpleBarReact>
    </div>
  );
}

export default AssetList;
